import { L1ObjectObjective } from 'core/l1Object/L1Object';
import {
  DefaultRtbCampaignBasicFormModel,
  RtbCampaignBasicFormModel,
} from './RtbCampaignBasicFormModel';
import {
  AdType,
  DailyBudgetPlan,
  DeliverType,
  RtbCampaignPlanType,
} from 'core/rtbCampaign/RtbCampaign';
import { L2ObjectOptimizationGoal } from 'core/l2Object/L2Object';
import { isEmpty, omitBy } from 'lodash';
import { RtbCampaignSetupFlowPageModel } from '../RtbCampaignSetupFlowPageModel';
export interface DisplayFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}
abstract class AbstractDisplayFormModel
  extends DefaultRtbCampaignBasicFormModel
  implements DisplayFormModel
{
  constructor(
    mode: 'create' | 'edit',
    flowModel: RtbCampaignSetupFlowPageModel,
  ) {
    super(mode, flowModel);
    this.defaultDeliverType = DeliverType.ACCELERATED;
  }

  async init() {}

  get campaignAdType(): AdType {
    return AdType.DISPLAY;
  }

  get needSetupAgeGender(): boolean {
    return true;
  }

  get showDeliverType(): boolean {
    return +this.modelDailyBudgetType === DailyBudgetPlan.DAILY;
  }

  getRtbOptionsMap() {
    const optionsMap = super.getRtbOptionsMap();
    return omitBy(
      {
        ...optionsMap,
        [L1ObjectObjective.TRAFFIC]: {
          [RtbCampaignPlanType.RS_CPM]: [L2ObjectOptimizationGoal.IMPRESSIONS],
        },
      },
      isEmpty,
    );
  }

  setupDefaultCampaign(campaign: any) {
    super.setupDefaultCampaign(campaign);
    campaign.dailyTargetBudget = 0;
  }
}

export class EditDisplayFormModel extends AbstractDisplayFormModel {
  constructor(flowModel: RtbCampaignSetupFlowPageModel) {
    super('edit', flowModel);
  }
  get canEditBudgetPlan(): boolean {
    return false;
  }
  get canEditPriceModel(): boolean {
    return false;
  }
}

export class CreateDisplayFormModel extends AbstractDisplayFormModel {
  constructor(flowModel: RtbCampaignSetupFlowPageModel) {
    super('create', flowModel);
    this.modelDailyBudgetType = DailyBudgetPlan.DAILY;
  }
  get canEditBudgetPlan(): boolean {
    return true;
  }
  get canEditPriceModel(): boolean {
    return true;
  }
}
